export const mutations = {

    'SET_CUSTOMERVOICE_POST_PAGE' (state, {customervoice_post_page}) {
        state.customervoice_post_page = customervoice_post_page ; 
    },
    'SET_CUSTOMERVOICE_POST_CONTENT_TYPE' (state, {customervoice_post_content_type}) {
        state.customervoice_post_content_type = customervoice_post_content_type ; 
    },

}